<!-- begin:: Footer -->
<div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop sumax-footer" id="kt_footer">
	<div class="kt-container" [ngClass]="{ 'kt-container--fluid': fluid }">
		<div class="kt-footer__copyright">
			{{ today | date : 'yyyy' }}&nbsp;&copy;&nbsp;<a href="https://www.sintad.pe/" target="_blank" rel="noopener noreferrer" class="kt-link">Sintad</a>
		</div>
		<div class="kt-footer__menu">
			@if (tipoCambio$ | async; as tipoCambio) {
				<div class="kt-footer__menu">{{ tipoCambio.fchCambio | date : 'dd/MM/yyyy' }}</div>
				<div class="kt-footer__menu">
					Valor:<strong class="kt-footer__value">&nbsp;{{ tipoCambio.tbMoneda?.codigo }}</strong>
				</div>
				<div class="kt-footer__menu">
					Compra:<span class="kt-footer__value">&nbsp;{{ tipoCambio.valorCompra | number : '1.3-3' }}</span>
				</div>
				<div class="kt-footer__menu">
					Venta:<span class="kt-footer__value">&nbsp;{{ tipoCambio.valorVenta | number : '1.3-3' }}</span>
				</div>
			} @else {
				<div class="kt-footer__menu">{{ today | date : 'dd/MM/yyyy' }}</div>
			}
			<a href="https://www.sintad.pe/contacto" target="_blank" rel="noopener noreferrer" class="kt-footer__menu-link kt-link">Contáctanos</a>
		</div>
	</div>
</div>
<!-- end:: Footer -->
